const config = {
    cdnUrl: process.env.NODE_ENV === 'development'
        ? '/cdn-proxy'
        : 'https://d2xto7y94gd4fj.cloudfront.net',
    defaultModelPath: '/assets/models/earring/scene.gltf',
    defaultNecklaceModelPath: '/assets/models/necklace/scene.glb'
};

export default config;
